import React from 'react';
import { Helmet } from 'react-helmet';

import { APP_DESCRIPTION, APP_TITLE } from '../constants';

export const HeadComponent = ({ title, description, canonicalLink, noIndex }) => (
    <Helmet>
        <title>{`${APP_TITLE}${title}`}</title>
        <meta name="description" content={description ? description : APP_DESCRIPTION} />
        {canonicalLink ? <link rel="canonical" href={canonicalLink} /> : ''}
        {noIndex ? <meta name="robots" content="noindex" /> : ''}
    </Helmet>
);



// WEBPACK FOOTER //
// ./src/components/HeadComponent.js